export default __webpack_public_path__ + "static/media/Pumpkin.5cff38bf.png";